import React, { useEffect } from 'react';
import LoginForm from './form';
import LoginBanner from './banner';
import styles from './style/index.module.less';
function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['banner-inner']
  }, /*#__PURE__*/React.createElement(LoginBanner, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null))));
}
Login.displayName = 'LoginPage';
export default Login;